export type MockMode = 'off' | 'all';

function mockMode(): MockMode {
  if (!import.meta.env.DEV) return 'off';
  const v = String(import.meta.env.VITE_MOCK ?? 'off');
  return v === 'all' ? 'all' : 'off';
}

export const config = {
  /** Base of the core API ('' = same origin). */
  apiBase: String(import.meta.env.VITE_API_BASE ?? '').replace(/\/+$/, ''),
  mock: mockMode(),
};

/** WebSocket URL of the core (/v1/ws), derived from the API base. */
export function wsUrl(): string {
  const base = config.apiBase || window.location.origin;
  const u = new URL(base + '/v1/ws', window.location.origin);
  u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
  return u.toString();
}
